import React from 'react'

function CancelPayment() {
  return (
    <div>Cancel payment</div>
  )
}

export default CancelPayment